import {getVal, isnull, isNum, wrapVal} from "../utils/tools";
import {loge} from "../utils/devext";
import global from "../config/global";

const { Realtime, TextMessage,AudioMessage, TypedMessagesPlugin, ImageMessage } = AV;
export default class IMHelper {
  static TAG = 'IMHelper'

  /**
   * 将leancloud的消息转化为消息实体
   * @param avimMessage
   * @return {*}
   */
  static parseMessage(message) {
    var msgType = TextMessage.TYPE
    var attrs = null
    var content = ""
    var duration = 0
    var awayDisId = ""
    var awayAccountId = 0
    var awayNickname = ""
    var awayAvatar = ""
    var imgWidth = 0
    var imgHeight = 0
    var lcFile=null
    var fileUrl = ""
    var fileLocalPath = ""
    let fileMetaData=""
    let type = message.type || message.content._lctype
    switch (type) {
      case TextMessage.TYPE:
        attrs = message.attributes||message.content._lcattrs;
        content = wrapVal(message.text, '')
        break;
      case ImageMessage.TYPE:
        msgType = ImageMessage.TYPE
        attrs =message.attributes||message.content._lcattrs;
        content = "[Image]"
        lcFile=message._lcfile||getVal(message.content,'_lcfile')
        fileMetaData=message.fileMetaData||getVal(lcFile,'metaData')
        fileUrl = message.fileUrl||getVal(lcFile,'url')
        fileLocalPath = message.localFilePath
        if (!isnull(fileMetaData)) {
          try {
            imgWidth = parseInt(fileMetaData.width)
            imgHeight = parseInt(fileMetaData.height)
          } catch (e) {
            loge(IMHelper.TAG, "图片消息解析失败" + e.message)
          }
        }
        break;
      case AudioMessage.TYPE:
        msgType = AudioMessage.TYPE
        attrs = message.attributes||getVal(message.content,'_lcattrs');
        content = "[Audio]"
        lcFile=message._lcfile||getVal(message.content,'_lcfile')
        fileMetaData=message.fileMetaData||getVal(lcFile,'metaData')
        fileUrl = message.fileUrl||getVal(lcFile,'url')
        fileLocalPath = message.localFilePath
        duration = parseInt(Math.ceil(message.duration).toFixed(0))
        if (!isNum(duration)||duration <= 0) {
          try {
            duration = parseInt(attrs["duration"].toString())
          } catch (e) {
            loge(IMHelper.TAG, "图片消息解析失败" + e.message)
          }
        }
        break;
      case 1:
        console.log('OperationMessage 是自定义消息类型');
      default:
        // 未来可能添加新的自定义消息类型，新版 SDK 也可能添加新的消息类型。
        // 因此别忘了在默认分支中处理未知类型，例如提示用户升级客户端至最新版本。
        console.warn('收到未知类型消息');
    }

    let isSelfSend = message.from == global.getUserDisplay()
    awayDisId = !isSelfSend ? getVal(attrs, 'userId', '') : getVal(attrs, 'targetUserId', '')
    let acc = !isSelfSend ? getVal(attrs, 'accountId', '') : getVal(attrs, 'targetAccountId', '')
    if (isNum(acc)) {
      awayAccountId = parseInt(acc)
    }


    awayNickname = !isSelfSend ? getVal(attrs, 'nickName', '') : getVal(attrs, 'targetNickName', '')
    awayAvatar = !isSelfSend ? getVal(attrs, 'headUrl', '') : getVal(attrs, 'targetAvatar', '')

    return {
      id:message.id,
      msgType: msgType,
      attrs: attrs,
      content: content,
      duration: duration,
      awayDisId: awayDisId,
      awayAccountId: awayAccountId,
      awayNickname: awayNickname,
      awayAvatar: awayAvatar,
      timestamp: message.timestamp.toString(),
      signture: this.getSignature(awayDisId),
      messageId: message.id,
      conversationId: message.conversationId,
      from: message.from,
      imgWidth: imgWidth,
      imgHeight: imgHeight,
      fileUrl: fileUrl,
      fileLocalPath: fileLocalPath
    }
  }

  /**
   * 实例化一个数据库会话对象
   */
  static instanceRoomConversation(conversation, parseMessage) {
    let roomConversation = {
      signature: parseMessage.signture,
      conversationId: conversation.id,
      // unreadCount: parseMessage.from == global.getUserDisplay() ? 0 : 1, // 默认一条消息就增加一条未读消息
      unreadCount: conversation.unreadMessagesCount, // 默认一条消息就增加一条未读消息
      timestamp: parseMessage.timeStamp,
      awayAvatar: parseMessage.awayAvatar,
      awayNickname: parseMessage.awayNickname,
      awayAccountId: parseMessage.awayAccountId,
      awayDisId: parseMessage.awayDisId,
      lastMsgContent: parseMessage.content,
      conversationType: parseMessage.awayDisId == global.getUserInfo('customDisplayAccountId') ? 1 : 0
    }
    return roomConversation
  }

  static instanceRoomMessage(parseMessage) {
    let roomMessage = {
      convType:parseMessage.convType,
      signature: parseMessage.signture,
      messageId: parseMessage.messageId,
      conversationId: parseMessage.conversationId,
      attr: parseMessage.attrs,
      msgType: parseMessage.msgType,
      content: parseMessage.content,
      timestamp: parseMessage.timeStamp,
      duration: parseMessage.duration,
      awayDisId: parseMessage.awayDisId,
      awayAccountId: parseMessage.awayAccountId,
      awayNickname: parseMessage.awayNickname,
      awayAvatar: parseMessage.awayAvatar,
      from: parseMessage.from,
      imgWidth: parseMessage.imgWidth,
      imgHeight: parseMessage.imgHeight,
      fileUrl: parseMessage.fileUrl,
      fileLocalPath: parseMessage.fileLocalPath
    }
    return roomMessage
  }


  static getSignature(awayDisId) {
    return global.getUserDisplay() + "&" + awayDisId;
  }

  static builderMessageAttr(curTargetPerson) {
    let map = {}
    //携带当前登录用户自己的信息
    let personData = global.getUser()
    map["headUrl"] = getVal(personData, 'avatar', '')
    map["nickName"] = getVal(personData, 'nickName', '')
    map["userId"] = getVal(personData, 'displayAccountId', '')
    map["accountId"] = getVal(personData, 'accountId', '')
    map["userlevel"] = getVal(personData, 'anchorLevel', '')

    map["targetAvatar"] = getVal(curTargetPerson, 'avatar', '')
    map["targetAccountId"] = getVal(curTargetPerson, 'accountId', '')
    map["targetNickName"] = getVal(curTargetPerson, 'nickName', '')
    map["targetUserId"] = getVal(curTargetPerson, 'displayAccountId', '')
    map["private"] = "private"

    // 自用
    map["timestamp"] = new Date().getTime()

    return map

  }
}



// WEBPACK FOOTER //
// ./src/im/IMHelper.js